import {
  getExperimentTreatment,
  getPersistedExperimentTreatment,
} from '@ms/yammer-data/dist/domains/experiments/selectors';
import type { YammerState } from '@ms/yammer-data/dist/state/types';

let isPersistedTreatmentEnabled: boolean | undefined = undefined;

export const debugSetIsEnabled = (value: boolean | undefined) => {
  isPersistedTreatmentEnabled = value;
};

type IsDogfoodPerfHUDEnabled = (state: YammerState, persistKey?: string) => Promise<boolean>;
export const isDogfoodPerfHUDEnabled: IsDogfoodPerfHUDEnabled = async (state, persistKey) => {
  const isTreatmentEnabled = getExperimentTreatment(state, 'DogfoodPerfHUD');
  if (!isTreatmentEnabled) {
    return false;
  }

  return await isDogfoodPerfHUDPersistEnabled(persistKey);
};

type IsDogfoodPerfHUDPersistEnabled = (persistKey?: string) => Promise<boolean>;
export const isDogfoodPerfHUDPersistEnabled: IsDogfoodPerfHUDPersistEnabled = async (persistKey) => {
  if (isPersistedTreatmentEnabled === true || isPersistedTreatmentEnabled === false) {
    return isPersistedTreatmentEnabled;
  }

  if (!persistKey) {
    return false;
  }

  const treatment = await getPersistedExperimentTreatment(persistKey, 'DogfoodPerfHUD');
  isPersistedTreatmentEnabled = treatment === true;

  return isPersistedTreatmentEnabled;
};
